import { CommunicationResource } from "../locales";

export const communication: CommunicationResource = {
    digitalMaterial: "Sähköinen materiaali",
    tastings: "Maistajaiset",
    storeMaterial: "Myymälämateriaali",
    campaignMaterial: "Kampanjamateriaalit",
    news: "Uutiset",
};
